export enum TitleEnum {
  MR = 'Mr',
  MRS = 'Mrs',
  MS = 'Ms',
}
